import React from "react"
import { VesselDetails } from "../hooks/usePrevetAPI"
import { Card } from "react-bootstrap"
import countryCodes from "data/countryCodes.json"

export function getAge(dateBuilt: string) {
  const buildDate = new Date(dateBuilt)
  const currentDate = new Date()

  let years = currentDate.getFullYear() - buildDate.getFullYear()
  let months = currentDate.getMonth() - buildDate.getMonth()

  // Adjust if the current month is earlier in the year than the build month
  if (months < 0) {
    years--
    months += 12
  }

  return { years, months }
}

const countryCodeMap = new Map(countryCodes.map((c) => [c.code, c]))

export function getCountryByCode(code: string): { name: string; alpha2: string } | undefined {
  return countryCodeMap.get(code.toUpperCase())
}

interface PrevetVesselInfoProps {
  vesselDetails: VesselDetails
  dateOfBuild: string
}

const PrevetVesselInfoCard = ({
  vesselDetails: VesselDetails,
  dateOfBuild,
}: PrevetVesselInfoProps) => {
  const country = VesselDetails.flag_state ? getCountryByCode(VesselDetails.flag_state) : undefined
  
  return (
    <>
      <Card.Body className="px-4">
        <div className="d-flex w-100 justify-content-between">
          <Card.Title>Vessel Info</Card.Title>
          {country && country.alpha2 && (
            <div className="d-flex flex-column gap-0 align-items-center">
              <span className={`fi fi-${country.alpha2}`} style={{ width: "3em", height: "3em", lineHeight: 1 }}></span>
              <div className="text-muted fs-6 text-center">{country.name}</div>
            </div>
          )}
        </div>

        {/* Vessel Name */}
        <div className="d-flex gap-1 align-items-baseline mt-5">
          {getAge(dateOfBuild).years === 0 &&
          getAge(dateOfBuild).months === 0 ? (
            <></>
          ) : (
            <>
              <h2>{getAge(dateOfBuild).years}</h2>
              <div className="fs-4">Years</div>
              <h5 className="text-muted">{getAge(dateOfBuild).months}</h5>
              <div className="text-muted">Months</div>
            </>
          )}
        </div>
        <table className="mt-3 w-100">
          <tbody>
            <tr>
              <td className="text-muted fs-6 w-50">IMO</td>
              <td className="text-muted fs-6">SUMMER DWT</td>
            </tr>
            <tr>
              <td className="text-black fs-4 w-50">{VesselDetails.imo}</td>
              <td className="text-black fs-4">{VesselDetails.dwt}</td>
            </tr>
            {/* divider */}
            <tr>
              <td>
                <div className="mt-2" />
              </td>
            </tr>
            <tr>
              <td className="text-muted fs-6 w-50">BUILT</td>
              <td className="text-muted fs-6">SUMMER DRAFT / TPC</td>
            </tr>
            <tr>
              <td className="text-black fs-4 w-50">{VesselDetails.built}</td>
              <td className="text-black fs-4">{VesselDetails.draft}</td>
            </tr>
            {/* divider */}
            <tr>
              <td>
                <div className="mt-2" />
              </td>
            </tr>
            <tr>
              <td className="text-muted fs-6 w-50">LOA / BEAM</td>
              <td className="text-muted fs-6">CUBICS</td>
            </tr>
            <tr>
              <td className="text-black fs-4 w-50">
                {VesselDetails.loa} / {VesselDetails.beam}m{" "}
              </td>
              <td className="text-black fs-4">{VesselDetails.cubic} cu.m</td>
            </tr>
            {/* divider */}
            <tr>
              <td>
                <div className="mt-2" />
              </td>
            </tr>
            <tr>
              <td className="text-muted fs-6 w-50">DESIGNER</td>
              <td className="text-muted fs-6">DESIGN</td>
            </tr>
            <tr>
              <td className="text-black fs-4 w-50">{VesselDetails.designer}</td>
              <td className="text-black fs-4">{VesselDetails.design}</td>
            </tr>
          </tbody>
        </table>
      </Card.Body>
    </>
  )
}

export default PrevetVesselInfoCard
